module.exports = __webpack_public_path__ + "static/img/bg.0ee6e811.png";